import { render } from "./CentreChequePage.vue?vue&type=template&id=4ec9d413"
import script from "./CentreChequePage.vue?vue&type=script&lang=js"
export * from "./CentreChequePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__